import Vue from 'vue';
import App from './App';
import router from './router';
import store from './store';
import Axios from 'axios';
import 'bootstrap';
import antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import './vee-validate';
import 'vue-search-select/dist/VueSearchSelect.css';
import Calendar from 'v-calendar/lib/components/calendar.umd';
import DatePicker from 'v-calendar/lib/components/date-picker.umd';

Vue.prototype.$http = Axios;
const token = localStorage.getItem('token');
if (token) {
  Vue.prototype.$http.defaults.headers.common['Authorization'] = token;
}
Vue.config.productionTip = false;
Vue.component('calendar', Calendar);
Vue.component('date-picker', DatePicker);
Vue.use(antd);
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
